import type { TypePolicies } from '../../../../utils/types/TypePolicies';
import { undoRedoCommandMap } from '../state';

export const typePolicies: TypePolicies = {
  Query: {
    fields: {
      getUndoRedoCommand: () => {
        return undoRedoCommandMap.get('default').activeCommand;
      },
    },
  },
};
